module.exports = __webpack_public_path__ + "img/organ5.e181945.png";